module.exports = {"150725100":"巴彦库仁镇","150725101":"宝日希勒镇","150725102":"呼和诺尔镇","150725200":"西乌珠尔苏木","150725201":"鄂温克民族苏木","150725202":"东乌珠尔苏木","150725203":"巴彦哈达苏木","150725501":"陈巴尔虎旗哈达图国营农牧场","150725502":"内蒙古自治区国有浩特陶海牧场","150725503":"陈巴尔虎旗特泥河农牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150725.json
// module id = 539
// module chunks = 0